import clienteAxios from '../config/axios';

import {
  REENVIAR_NOTIFICACION_TURNO_EXITO
} from '../types';

// Reencola manualmente una notificación de turno.
// Se usa solamente para estados REBOTADO o ERROR.
// El backend toma profesional_id desde el token, por eso no se manda desde el front.
export function reenviarNotificacionTurnoAction(informacion) {
  return async (dispatch) => {
    const { config, payload } = informacion;

    try {
      const respuesta = await clienteAxios.post('/paciente/reenviarnotificacionturno', payload, config);

      dispatch(reenviarNotificacionTurnoExito(respuesta.data));

      return respuesta.data;

    } catch (error) {
      const mensaje =
        error.response?.data?.msg ||
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Error interno al volver a poner la notificación en cola.';

      error.userMessage = mensaje;

      throw error;
    }
  };
}

const reenviarNotificacionTurnoExito = (payload) => ({
  type: REENVIAR_NOTIFICACION_TURNO_EXITO,
  payload
});